import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./context/authContext"; // Import the useAuth hook from your AuthContext

const ProtectedRoute = ({ children }) => {
	const { isAuthenticated, user, sendOtp } = useAuth(); // Check if the user is authenticated

	const handleSendOtp = async () => {
		await sendOtp(user.user_id);
		window.location.href = "/verify-email";
		return null;
	};

	if (!isAuthenticated) {
		console.log("Navigating");
		console.log(user);
		window.location.href = "/login";
		return null;
	}

	return children ? children : <Outlet />;
};

export default ProtectedRoute;
